import React, { useEffect } from 'react';
import is from 'is_js';
import { Outlet,useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Chart as ChartJS, registerables } from 'chart.js';
import { CloseButton } from 'components/common/toast';
import ErrorBoundary from 'components/common/errorBoundary';
// import SettingsToggle from 'components/settings-panel/SettingsToggle';
// import SettingsPanel from 'components/settings-panel/SettingsPanel';
import { useAppContext } from 'providers/appProvider';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/site.css';
import useCultureChange from '../src/culture/useCultureChange'; // import the hook
import useSocket from 'hooks/useSocket';               
import { toast } from 'react-toastify';                 
import paths from 'routes/paths';
import USER_ROLES from 'config/roles.config';
import { useTranslation } from 'react-i18next';
import { disconnectSocket } from 'assets/js/common';


ChartJS.register(...registerables);

const FORCE_LOGOUT_MESSAGES = {
  ACCOUNT_DEACTIVATED: "accountDisabledLoggedOut",
  CUSTOMER_DELETED: "accountDeletedLoggedOut",
  ACCOUNT_OFFBOARDED: "accountOffboardedLoggedOut",
};

const App = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  useCultureChange();

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useAppContext();

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

useEffect(() => {
    const token = localStorage.getItem("token");
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    const isOnLoginPage = location.pathname === "/login";

    if (token && isLoggedIn && isOnLoginPage) {
      navigate("/dashboard");
    }
  }, [location.pathname, navigate]);

  // force-logout handling for account Disable / Delete — applies to everyone
  const performForceLogout = (reason) => {
    disconnectSocket();
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem("logoutReason", reason || "sessionEnded");
    toast.error(
      t(FORCE_LOGOUT_MESSAGES[reason] || "sessionEnded"),
      { position: "top-right", autoClose: 6000 }
    );
    navigate(paths.login, { replace: true });
  };

  useSocket('force-logout', ({ reason }) => {
    performForceLogout(reason);
  });

  useSocket('force-logout-non-admin', ({ reason }) => {
    const userRole = localStorage.getItem("UserRole");
    const isAdminOrAppOwner = userRole === USER_ROLES.ADMIN || userRole === USER_ROLES.APP_OWNER;

    if (!isAdminOrAppOwner) {
      performForceLogout(reason);
      return;
    }

    const isOffboardedElsewhere = reason === "ACCOUNT_OFFBOARDED" && location.pathname !== "/dashboard";
    if (isOffboardedElsewhere) {
      navigate("/dashboard", { replace: true });
    }
  });


  return (
    <>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      {/* <SettingsToggle /> */}
      {/* <SettingsPanel /> */}
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-left"
        autoClose={5000}
      />
    </>
  );
};

export default App;